import {inject} from '@angular/core';

import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {tapResponse} from '@ngrx/operators';
import {rxMethod} from '@ngrx/signals/rxjs-interop';
import {withDevtools} from '@angular-architects/ngrx-toolkit';

import {pipe, tap, switchMap} from 'rxjs';

import {RequestStatus} from '@selpia/shared/data-access';
import {Measure} from '@selpia/shared/models';

import {MeasureService} from '../data-services/measures.service';

export type MeasuresState = {
  loadingStatus: RequestStatus;
  measures: Measure[] | undefined;
};

const initialMeasuresState: MeasuresState = {
  loadingStatus: RequestStatus.Resolved,
  measures: undefined,
};

export const MeasureStore = signalStore(
  {providedIn: 'root'},
  withDevtools('measures'),
  withState(initialMeasuresState),
  withMethods((store, measureService = inject(MeasureService)) => ({
    load: rxMethod<void>(
      pipe(
        tap(() => patchState(store, {loadingStatus: RequestStatus.Pending})),
        switchMap(() => {
          return measureService.getMeasures()
            .pipe(
              tapResponse({
                next: (measures: Measure[]) => patchState(store, {loadingStatus: RequestStatus.Resolved, measures}),
                error: () =>
                  patchState(store, {
                    loadingStatus: RequestStatus.Rejected,
                  }),
              }),
            );
        }),
      ),
    ),
  })),
);
export type MeasureStore = InstanceType<typeof MeasureStore>;
